import { useState } from 'react';
import { useClub } from '../../hooks/useClub';
import T2MOverview from '../t2m/T2MOverview';
import PB101Overview from '../pb101/PB101Overview';
import LeadOverview from '../lead/LeadOverview';

const MODULE_TABS = [
  { key: 't2m',   label: '🌱 Trial to Member' },
  { key: 'pb101', label: '🎓 PB101' },
  { key: 'lead',  label: '📋 Lead Engine' },
];

const DATE_RANGES = [
  { key: '7',  label: 'Last 7d' },
  { key: '30', label: 'Last 30d' },
  { key: '90', label: 'Last 90d' },
];

export default function KPIDashboard() {
  const { currentClub } = useClub();
  const [activeModule, setActiveModule] = useState('t2m');
  const [dateRange, setDateRange]       = useState('30');

  return (
    <div className="module-page">
      {/* Header */}
      <div style={{ marginBottom: 20 }}>
        <div style={{ display: 'flex', alignItems: 'flex-start', justifyContent: 'space-between', flexWrap: 'wrap', gap: 12 }}>
          <div>
            <h1 style={{ fontSize: 22, fontWeight: 800, color: 'var(--text)', margin: 0, marginBottom: 4 }}>
              📊 KPI Dashboard
            </h1>
            <div style={{ fontSize: 12, color: 'var(--text-muted)' }}>
              {currentClub?.name || 'All Clubs'} · All Sales Modules
            </div>
          </div>

          {/* Date range filter */}
          <div style={{ display: 'flex', gap: 6 }}>
            {DATE_RANGES.map(r => (
              <button
                key={r.key}
                onClick={() => setDateRange(r.key)}
                style={{
                  background: dateRange === r.key ? 'var(--yellow)' : 'var(--surface-2)',
                  color: dateRange === r.key ? '#000' : 'var(--text-muted)',
                  border: `1px solid ${dateRange === r.key ? 'var(--yellow)' : 'var(--border)'}`,
                  borderRadius: 6, padding: '5px 14px', fontSize: 12,
                  fontWeight: dateRange === r.key ? 700 : 400, cursor: 'pointer',
                }}
              >
                {r.label}
              </button>
            ))}
          </div>
        </div>
      </div>

      {/* Module tabs */}
      <div style={{ display: 'flex', gap: 0, marginBottom: 20, borderBottom: '1px solid var(--border)' }}>
        {MODULE_TABS.map(t => (
          <button
            key={t.key}
            onClick={() => setActiveModule(t.key)}
            style={{
              background: 'none', border: 'none',
              borderBottom: activeModule === t.key ? '2px solid var(--yellow)' : '2px solid transparent',
              color: activeModule === t.key ? 'var(--yellow)' : 'var(--text-muted)',
              padding: '10px 20px', fontSize: 13,
              fontWeight: activeModule === t.key ? 700 : 400,
              cursor: 'pointer', marginBottom: -1,
              transition: 'color 0.15s',
            }}
          >
            {t.label}
          </button>
        ))}
      </div>

      {/* Module content — reuse existing overview components */}
      {activeModule === 't2m'   && <T2MOverview   key={`t2m-${dateRange}`}   days={parseInt(dateRange)} />}
      {activeModule === 'pb101' && <PB101Overview key={`pb101-${dateRange}`} days={parseInt(dateRange)} />}
      {activeModule === 'lead'  && <LeadOverview  key={`lead-${dateRange}`}  days={parseInt(dateRange)} />}
    </div>
  );
}
